'use strict';

angular.module('licensure.services')
    .factory('UserStatuses', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/userstatuses', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getUserStatusLockedMessage: function (statusId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Core/UserStatus/' + statusId + '/LockedMessage', {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;